exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-content {\n  height: 100%;\n  padding-left: 1rem;\n}\n.fm-content .fm-content-body {\n  overflow: auto;\n}", ""]);

// exports
